import React from 'react';
import { Form, Input, Icon, Table } from 'semantic-ui-react';
import * as _ from 'lodash';

import CustomDropdown from '../../../common/CustomDropdown';

const partInitValue = { picklistId: '', picklistOptionId: '', quantity: 0 };

const findOptionForSelectedPicklist = (id, items) => {
  const itemsDict = _.keyBy(items, 'key');
  const reqPicklist = itemsDict[id];
  const options = _.get(reqPicklist, 'originalobject.options', {});
  return Object.values(options).map((option) => {
    return { key: option.id, value: option.id, text: option.name };
  });
};

const PartsComponent = ({ partsPicklist, formik }) => {
  const handleFieldChange = (event, isDropdown, data, index) => {
    let field;
    let value;
    const partsClone = _.cloneDeep(formik.values.parts_required);
    if (!isDropdown) {
      field = event.target.name;
      value = event.target.value;
    } else {
      field = data.name;
      value = data.value;
    }
    if (field === 'picklistId') {
      partsClone[index] = { picklistId: value, picklistOptionId: '', quantity: 0 };
    }
    partsClone[index] = { ...partsClone[index], [field]: value };
    const reqPart = partsClone[index];
    if (index + 1 === partsClone.length && reqPart.quantity && reqPart.picklistOptionId && reqPart.picklistId) {
      partsClone.push(partInitValue);
    }
    formik.setFieldValue('parts_required', partsClone, false);
  };

  const handleDeleteRow = (index) => {
    const partsClone = _.cloneDeep(formik.values.parts_required);
    const errorClone = _.cloneDeep(formik.errors.parts_required);
    if (errorClone) {
      errorClone.splice(index, 1);
      formik.setFieldError('parts_required', errorClone);
    }
    partsClone.splice(index, 1);
    formik.setFieldValue('parts_required', partsClone, false);
  };

  return (
    <>
      <Table id="partsTable">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>S No</Table.HeaderCell>
            <Table.HeaderCell>Picklist</Table.HeaderCell>
            <Table.HeaderCell>Parts</Table.HeaderCell>
            <Table.HeaderCell>Quantity</Table.HeaderCell>
            <Table.HeaderCell>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {_.get(formik, 'values.parts_required', []).map((part, index) => (
          <Table.Body key={index}>
            <Table.Row>
              <Table.Cell>
                <Form.Field>
                  <label>{index + 1}</label>
                </Form.Field>
              </Table.Cell>
              <Table.Cell>
                <Form.Field style={{ height: '50px' }}>
                  <CustomDropdown
                    placeholder="Choose parts picklist"
                    search
                    selection
                    options={partsPicklist}
                    value={part.picklistId}
                    onChange={(event, data) => {
                      handleFieldChange(event, true, data, index);
                    }}
                    disabled={partsPicklist && partsPicklist.isLoading}
                    name="picklistId"
                  />
                  {formik.errors.parts_required &&
                    formik.errors.parts_required[index] &&
                    formik.errors.parts_required[index].picklistId && (
                      <div className="errorText">*{formik.errors.parts_required[index].picklistId}</div>
                    )}
                </Form.Field>
              </Table.Cell>
              <Table.Cell>
                <Form.Field style={{ height: '50px' }}>
                  <CustomDropdown
                    placeholder="Choose part"
                    search
                    selection
                    name="picklistOptionId"
                    value={part.picklistOptionId}
                    options={findOptionForSelectedPicklist(part.picklistId, partsPicklist.items)}
                    onChange={(event, data) => {
                      handleFieldChange(event, true, data, index);
                    }}
                  />
                  {formik.errors.parts_required &&
                    formik.errors.parts_required[index] &&
                    formik.errors.parts_required[index].picklistOptionId && (
                      <div className="errorText">*{formik.errors.parts_required[index].picklistOptionId}</div>
                    )}
                </Form.Field>
              </Table.Cell>
              <Table.Cell>
                <Form.Field style={{ height: '50px' }}>
                  <Input
                    type="number"
                    name="quantity"
                    onChange={(event, data) => {
                      handleFieldChange(event, false, data, index);
                    }}
                    value={part.quantity}
                    min="0"
                  />
                  {formik.errors.parts_required &&
                    formik.errors.parts_required[index] &&
                    formik.errors.parts_required[index].quantity && (
                      <div className="errorText">*{formik.errors.parts_required[index].quantity}</div>
                    )}
                </Form.Field>
              </Table.Cell>
              <Table.Cell>
                <Form.Field>
                  {index + 1 !== _.get(formik, 'values.parts_required', []).length ? (
                    <div onClick={() => handleDeleteRow(index)}>
                      <Icon name="trash alternate outline" />
                    </div>
                  ) : (
                    <div>
                      <Icon name="trash alternate outline" disabled />
                    </div>
                  )}
                </Form.Field>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        ))}
      </Table>
    </>
  );
};

export default PartsComponent;
